/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import * as strings from '@touchplan/strings';

export interface IPpcFormatMapValue {
	sortingOrdinal: number;
	format: PpcFormat;
}

export enum PpcFormat {
	PpcByWeek = 'ppcChartsByWeek',
	PpcByRole = 'ppcChartsByTradeToDate',
	PpcByVarianceReason = 'ppcChartsByVarianceReason',
	VarianceByRole = 'ppcVarianceByRole',
	VarianceByWeek = 'ppcVarianceByWeek',
}

export const ppcFormatLabelMap = new Map<string, IPpcFormatMapValue>([
	[strings.REPORT_PPC_FORMAT_PPC_BY_WEEK, { sortingOrdinal: 10, format: PpcFormat.PpcByWeek }],
	[strings.REPORT_PPC_FORMAT_PPC_BY_ROLE, { sortingOrdinal: 20, format: PpcFormat.PpcByRole }],
	[strings.REPORT_PPC_FORMAT_PPC_BY_VARIANCE, { sortingOrdinal: 30, format: PpcFormat.PpcByVarianceReason }],
	[strings.REPORT_PPC_FORMAT_VARIANCE_BY_ROLE, { sortingOrdinal: 40, format: PpcFormat.VarianceByRole }],
	[strings.REPORT_PPC_FORMAT_VARIANCE_BY_WEEK, { sortingOrdinal: 50, format: PpcFormat.VarianceByWeek }],
]);
